module.exports = __webpack_public_path__ + "img/Proctoringred.cc2002fb.svg";